/* eslint-disable eag/match-named-export, eag/no-index -- Pre-existing grab-bag file with several exports. Pre-existing violation */
export const CLOSING_DAY_DIALOG_ID = 'closing-day-dialog';
export const CLOSING_DAY_GRID_CODE = 'closing-day';
